var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.65625 0 0 2.71875 0 6C0 8.25 0.71875 8.9375 4.71875 15.3125C5.3125 16.25 6.65625 16.25 7.25 15.3125C11.25 8.9375 12 8.25 12 6C12 2.6875 9.28125 0 6 0ZM6 14.5C2 8.125 1.5 7.71875 1.5 6C1.5 3.53125 3.5 1.5 6 1.5C8.46875 1.5 10.5 3.53125 10.5 6C10.5 7.71875 10 8.0625 6 14.5ZM3.5 6C3.5 7.40625 4.59375 8.5 6 8.5C7.375 8.5 8.5 7.40625 8.5 6C8.5 4.625 7.375 3.5 6 3.5C4.59375 3.5 3.5 4.625 3.5 6Z",
    fill: "#758BA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.82af16d5.svg";
export { ForwardRef as ReactComponent };